import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://a3d1kmonz2.execute-api.us-east-1.amazonaws.com/dev';

/**
 * Submit or update a vibe check reaction for an outfit.
 * If the user already reacted with a different emoji, the previous reaction is replaced.
 * If the user reacts with the same emoji, the backend toggles it off.
 */
export async function submitReaction(outfitId: string, emoji: string): Promise<void> {
  // TODO (task 5.3): Wire to POST /outfits/{outfitId}/reactions endpoint
  await axios.post(`${API_BASE}/outfits/${outfitId}/reactions`, { emoji });
}

/**
 * Get aggregate reaction counts for an outfit.
 */
export async function getReactions(outfitId: string): Promise<{ [emoji: string]: number }> {
  // TODO (task 5.3): Wire to GET /outfits/{outfitId}/reactions endpoint
  const response = await axios.get(`${API_BASE}/outfits/${outfitId}/reactions`);
  return response.data.reactions ?? {};
}

/**
 * Get the current user's reaction for an outfit.
 */
export async function getUserReaction(outfitId: string): Promise<string | null> {
  // TODO (task 5.3): Wire to GET /outfits/{outfitId}/reactions/me endpoint
  const response = await axios.get(`${API_BASE}/outfits/${outfitId}/reactions/me`);
  return response.data.emoji ?? null;
}

/**
 * Remove the current user's reaction from an outfit.
 */
export async function removeReaction(outfitId: string): Promise<void> {
  // TODO (task 5.3): Wire to DELETE /outfits/{outfitId}/reactions endpoint
  await axios.delete(`${API_BASE}/outfits/${outfitId}/reactions`);
}
